<div class="dialog-wrap">
  <span class="material-symbols-outlined warning-icon"> warning </span>
  <h3>{{"GENIUS_SETTINGS.SUBSCRIPTIONS_ERROR.HEADING" | translate}}</h3>
<!--  <div class="subscription-type" *ngIf="userDevice">-->
<!--    <span>{{"GENIUS_SETTINGS.SUBSCRIPTIONS_ERROR.SUBSCRIPTION_TYPE" | translate}}</span>-->
<!--    <span class="type">{{userDevice.subscriptionType === 'month' ?-->
<!--      ("GENIUS_SETTINGS.SUBSCRIPTIONS_ERROR.MONTH" | translate) :-->
<!--      ("GENIUS_SETTINGS.SUBSCRIPTIONS_ERROR.YEAR" | translate)-->
<!--      }}-->
<!--    </span>-->
<!--  </div>-->
  <button mat-raised-button color="primary" class="shop-button" (click)="toShop()">{{"GENIUS_SETTINGS.SUBSCRIPTIONS_ERROR.TO_SHOP" | translate}}</button>
</div>
